export const token_corregidora = () => { 
    const token = localStorage.getItem('token_corregidora');
    // if (!isAdmin) {
    //     const newToken = `\"${token}\"`;
    //     localStorage.setItem('mcp-id_token', newToken);
    // }
    return token;
}